<template>
  <div class="seckill-grid-item-component">
    <router-link class="seckill-grid-item-content"
                 :to="getProductPath(item.target.type, item.target.id)"
    >
      <ym-img class="seckill-grid-item-cover"
              :src="item.cover"
              :format="format"
              :resize="{ w: 280, h: 210 }"
      />
      <div class="seckill-grid-item-content--right">
        <div class="seckill-grid-item-title ym-ellipsis-two">{{ item.title }}</div>
        <div class="seckill-grid-item-quota">
          限量 {{ item.seckill.quota }}份
        </div>
        <div v-if="price"
             class="seckill-grid-item-price"
        >
          <ym-price :name="price.name"
                    :value="price.value"
          />
          <ym-price name="原价"
                    :value="price.delete"
                    type="delete"
          />
        </div>
      </div>
    </router-link>
    <ym-button v-if="button"
               class="seckill-grid-item-button"
               :type="button.type"
               :plain="button.plain"
               :disabled="renderButtonDisabled"
               v-ym-report:SECKILL_PRODUCT_BTN_CLICK="item"
               v-html="renderButtonHint"
               @click="mixinHandleClickSeckillBtn(button)"
    ></ym-button>
  </div>
</template>

<script>
  import Button from '@/pages/Seckill/components/SeckillBtn';
  import Price from '@/pages/Seckill/components/SeckillPrice';
  import seckillDoSeckillMixin from '@/mixins/seckill/doSeckill';
  import { getProductPath } from '@/utils';
  import CountDown from '@/utils/count-down';
  import { PER_MINUTE } from '@/utils/constant';

  export default {
    name: 'SeckillGridItem',
    mixins: [seckillDoSeckillMixin],
    components: {
      'ym-button': Button,
      'ym-price': Price,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      startTime: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        buttonHint: '',
      };
    },
    computed: {
      price() {
        return this.item.render.price;
      },
      button() {
        return this.item.render.button;
      },
      format() {
        const { cover } = this.item;
        const res = cover.match(/.(jpg|png|jpeg|webp|bmp|gif|tiff)/)[0].replace('.', '');
        return res === 'jpeg' ? 'jpg' : res;
      },
      renderButtonHint() {
        const { buttonHint, button } = this;
        if (buttonHint !== '') return buttonHint;
        return button.hint;
      },
      renderButtonDisabled() {
        const { buttonHint, button } = this;
        return buttonHint !== '' ? true : button.disabled;
      },
    },
    watch: {
      buttonHint(val) {
        if (val !== '') {
          this.$emit('show-guide-mask');
        }
      },
    },
    methods: {
      getProductPath,
      initCountDown() {
        const { startTime, item: { seckill: { startTime: endTime } } } = this;
        const minutes10 = (PER_MINUTE * 10) / 1000;
        new CountDown({
          startTime,
          endTime,
          render: (data) => {
            if (endTime - startTime <= minutes10) {
              const { minutes, seconds } = data;
              const res = `${minutes}:${seconds}`;
              this.buttonHint = `<span class="count-down">${res}</span> 后开始秒杀`;
            }
          },
          end: () => {
            this.buttonHint = '';
            this.item.render.button.disabled = false;
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-grid-item {
    &-component {
      overflow: hidden;
      padding: @size-large @size-medium 0;
      text-align: left;
    }

    &-content {
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &--right {
        align-self: stretch;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
      }
    }

    &-cover {
      overflow: hidden;
      width: 280px;
      height: 210px;
      margin-right: @size-base;
      flex-shrink: 0;
      border-radius: @seckill-item-cover-border-radius;
    }

    &-title {
      font-size: @font-size-medium;
    }

    @item-quota-height: 44px;

    &-quota {
      width: auto;
      height: @item-quota-height;
      padding: 0 @size-small;
      line-height: @item-quota-height;
      color: @seckill-highlight;
      border-radius: @seckill-item-cover-border-radius;
      background: fade(@seckill-highlight, 15%);
    }

    &-price {
      align-self: stretch;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    &-button {
      min-width: 420px;
      margin: @size-extra-medium auto 0;

      /deep/ .count-down {
        display: inline-block;
        min-width: 90px;
        text-align: center;
      }
    }
  }
</style>
